import type { Revieve, RevieveUserId } from 'revieve';

import {
  ONE_TRUST_GROUP_PERFORMANCE,
  OPTANON_CONSENT_COOKIE,
  REVIEVE_USER_ID_COOKIE,
} from '../constants';
import { getCookie } from './cookies';

export const getRevieveUserId = (): RevieveUserId | undefined => getCookie(REVIEVE_USER_ID_COOKIE);

export const hideRevieve = () => window.Revieve?.API.hide();

export const initRevieve: Revieve['Init'] = (config, callback) =>
  // eslint-disable-next-line new-cap -- 3rd party naming
  window.Revieve?.Init(config, callback);

export const isAnalyticsConsentGranted = (): boolean => {
  if (!getCookie(OPTANON_CONSENT_COOKIE)) {
    return true;
  }

  return new RegExp(`groups=[^;]*${ONE_TRUST_GROUP_PERFORMANCE}%3A1`).test(
    getCookie(OPTANON_CONSENT_COOKIE) ?? '',
  );
};

export const showRevieve = () => window.Revieve?.API.show();

export const unmountRevieve = () => window.Revieve?.API.unmount();
